import * as React from "react";
const SvgIconChartGantt = (props) => /* @__PURE__ */ React.createElement("svg", { style: {
  width: 24,
  height: 24
}, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M2,5H10V2H12V22H10V18H6V15H10V13H4V10H10V8H2V5M14,5H17V8H14V5M14,10H19V13H14V10M14,15H22V18H14V15Z" }));
export default SvgIconChartGantt;
